import React from 'react'
import { TableCell, TableRow, Chip, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import { STATUS_COLOR_MAP } from '../../../../constant/status'
import ReadMoreIcon from '@mui/icons-material/ReadMore'

const Row = ({ row }) => {
  // Shorten type to optimise space
  const type = row.type.includes('TNG') ? 'TNG' : 'CAR'

  return (
    <TableRow>
      <TableCell>
        <Chip
          label={row.status}
          color={STATUS_COLOR_MAP[row.status]}
          size='small'
          style={{ fontWeight: 900 }}
        />
      </TableCell>
      <TableCell>{type}</TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>{row.state}</TableCell>
      <TableCell>{row.brand}</TableCell>
      <TableCell>{row.serialNumber}</TableCell>
      <TableCell>{row.phone}</TableCell>
      <TableCell align='right'>
        <Link to={`./${row._id}`} style={{ textDecoration: 'none' }}>
          <IconButton aria-label='review' size='small'>
            <ReadMoreIcon></ReadMoreIcon>
          </IconButton>
        </Link>
      </TableCell>
    </TableRow>
  )
}

export default Row
